var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 480,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 689,
    y: 105,
    width: 480,
    height: 480
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-689 -105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M928.895 165C1028.25 165 1108.79 245.542 1108.79 344.895 1108.79 444.249 1028.25 524.79 928.895 524.79 829.542 524.79 749 444.249 749 344.895 749.113 245.589 829.589 165.113 928.895 165M928.895 155C824.019 155 739 240.019 739 344.895 739 449.771 824.019 534.79 928.895 534.79 1033.77 534.79 1118.79 449.771 1118.79 344.895 1118.84 240.066 1033.89 155.047 929.065 155 929.009 155 928.951 155 928.895 155Z",
    stroke: "#FFFFFF",
    strokeWidth: 17.3333,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.895 415 923.895 415 923.895 356.635 928.895 356.635C962.485 356.638 989.717 329.41 989.72 295.82 989.723 262.23 962.495 234.998 928.905 234.995 895.315 234.992 868.083 262.22 868.08 295.81 868.08 295.811 868.08 295.814 868.08 295.815L858.08 295.815C858.081 256.702 889.789 224.995 928.901 224.996 968.014 224.997 999.72 256.705 999.72 295.818 999.719 332.992 970.977 363.838 933.895 366.46Z",
    stroke: "#FFFFFF",
    strokeWidth: 17.3333,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939 450C939 455.523 934.523 460 929 460 923.477 460 919 455.523 919 450 919 444.477 923.477 440 929 440 934.523 440 939 444.477 939 450Z",
    stroke: "#FFFFFF",
    strokeWidth: 17.3333,
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpLight);
export default __webpack_public_path__ + "static/media/help_light.071a9a469696c1a91aad4d104b065cb8.svg";
export { ForwardRef as ReactComponent };